import { Box, Typography } from "@mui/material";

const CellEmptyPlaceholder = () => (
  <Box
    sx={{
      flex: 1,
      width: "100%",
      minHeight: "100%",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      gap: 0.5,
      color: "#94a3b8",
      pointerEvents: "none",
      userSelect: "none",
    }}
  >
    <Typography
      sx={{
        fontSize: 22,
        fontWeight: 300,
        lineHeight: 1,
        color: "#cbd5e1",
      }}
    >
      +
    </Typography>
    <Typography variant="caption" sx={{ fontSize: 10, textAlign: "center", px: 1 }}>
      Trascina un componente
    </Typography>
  </Box>
);

export default CellEmptyPlaceholder;
 